import { render, staticRenderFns } from "./business-forms-provider.vue?vue&type=template&id=1109054a"
import script from "./business-forms-provider.vue?vue&type=script&lang=js"
export * from "./business-forms-provider.vue?vue&type=script&lang=js"
import style0 from "./business-forms-provider.vue?vue&type=style&index=0&id=1109054a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports